import { USER_SET_DATA, USER_FINISH_LOADING, USER_START_LOADING, USER_SET_ERROR } from '../actionTypes';

const initialState = {
  loading: true,
  error: null,
  data: null,
};

const handleSetData = ({ state, payload: { data } }) => {
  return {
    ...state,
    loading: false,
    data,
  };
};

const handleStartLoading = ({ state }) => {
  return {
    ...state,
    loading: true,
  };
};

const handleFinishLoading = ({ state }) => {
  return {
    ...state,
    loading: false,
  };
};

const handleSetError = ({ state, payload: { error } }) => {
  return {
    ...state,
    loading: true,
    error,
  };
};

const handlers = {
  [USER_SET_DATA]: handleSetData,
  [USER_SET_ERROR]: handleSetError,
  [USER_START_LOADING]: handleStartLoading,
  [USER_FINISH_LOADING]: handleFinishLoading,
};

export default function (state, { type, ...payload }) {
  if(!state) state = initialState;
  
  const handler = handlers[type];

  if (!handler) return state;

  return handler({ state, payload });
}
